<template>
  <div class="address-form">
    <div style="height: 10px"></div>
    <van-cell-group>
      <van-field
        input-align="right"
        v-model="formData.name"
        label="联系人"
        :error="formValidate && !formData.name"
        placeholder="请输入联系人"
      />
      <van-field
        input-align="right"
        v-model="formData.phone"
        label="手机号码"
        :error="formValidate && !formData.phone"
        type="number"
        placeholder="请输入手机号码"
      />
      <van-field
        input-align="right"
        @click="area_show = true"
        readonly
        :value="formData.province + formData.city + formData.county"
        :error="formValidate && !formData.county"
        label="选择地区"
        placeholder="请选择地区"
      />
      <van-field
        input-align="right"
        v-model="formData.address"
        label="详细地址"
        type="textarea"
        :error="formValidate && !formData.address"
        placeholder="请输入街道门牌信息"
      />
      <van-field
        input-align="right"
        v-model="formData.code"
        label="邮政编码"
        :error="formValidate && !formData.phone"
        type="number"
        placeholder="请输入邮政编码"
      />
      <van-cell title="是否设为默认">
        <van-switch
          size="24px"
          active-color="#FCAB15"
          v-model="switchCheck"
        />
      </van-cell>
    </van-cell-group>

    <div style="padding: 20px; text-align: center">
      <van-button round size="large" @click.stop="formSave" class="save"
        >保存</van-button
      >
    </div>
    <div
      @click="onDelete"
      style="padding-top: 10px; color: #666; text-align: center"
    >
      删除
    </div>
    <div
      v-show="area_show"
      style="position: fixed; bottom: 0; z-index: 1000; width: 100%"
    >
      <van-popup
        style="top: 50%"
        position="bottom"
        :close-on-click-overlay="false"
        v-model="show"
      >
        <van-area
          :area-list="areaList"
          :value="formData.area_key"
          @confirm="areaConfirm"
          @cancel="areaCancel"
        />
      </van-popup>
    </div>
  </div>
</template>
<style scoped>
.address-form {
  background: #f8f8f8;
  height: 843px;
}
.van-cell:not(:last-child)::after {
  right: 16px;
}
.save {
  width: 155px;
  height: 46px;
  background: linear-gradient(316deg, #f8d77f 0%, #fcab15 100%);
  border-radius: 23px;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #ffffff;
  line-height: 20px;
  text-align: center;
}
</style>
<script>
import Vue from "vue";
import { Popup, CellGroup, Cell, Switch, Area, Dialog, Toast } from "vant";
import areaList from "@/utils/area";

export default {
  name: "AddressList",

  data() {
    return {
      show: true,
      formData: {
        id: "",
        name: "",
        phone: "",
        area_names_string: "",
        area_key: "",
        address: "",
        province: "",
        city: "",
        county: "",
        is_default: true,
      },
      selectAddress: {},
      areaList: areaList,
      list: [],
      area_show: false,
      formValidate: false,

      switchCheck: false,
    };
  },
  components: {
    [Popup.name]: Popup,
    [CellGroup.name]: CellGroup,
    [Cell.name]: Cell,
    [Switch.name]: Switch,
    [Area.name]: Area,
    Dialog,
    Toast,
  },
  mounted: function () {
    document.title = "编辑收货地址";
    this.getAddressDetail();
  },
  methods: {
    onSelect(address) {
      let that = this;
      that.selectAddress = address;
      that.onChange();
    },
    getAddressDetail() {
      let that = this;
      let id = this.$route.query.id;
      this.$api.get("/api/user/addressDetail", { id: id }, (res) => {
        that.formData = res.data;
        if (res.data.is_default == 1) {
          that.switchCheck = true;
        }
      });
    },

    onChange() {
      this.$router.go(-1);
      // this.$router.replace('addresslist');
    },
    areaConfirm(data) {
      let that = this;
      console.log(data);
      that.formData.province = data[0].name;
      that.formData.city = data[1].name;
      that.formData.county = data[2].name;
      that.formData.area_key = data[2].code;
      that.formData.area_names_string =
        data[0].name + "-" + data[1].name + "-" + data[2].name;
      this.area_show = false;
    },
    areaCancel() {
      this.area_show = false;
    },

    formSave: function () {
      let that = this;
      that.formValidate = true;
      that.formData.is_default = that.switchCheck == true ? 1 : 2;

      console.log("that.formData", that.formData);

      /*for(let field in that.formData){
                  if (!that.formData[field] && field !='is_default'){
                    return ;
                  }
                };*/

      this.$api.get(
        "/api/user/addressEdit",
        that.formData,
        (res) => {
          that.onChange();
        },
        (res) => {
          Toast(res.msg);
        }
      );
    },

    onDelete() {
      Dialog.confirm({
        title: "提示",
        message: "确定要删除吗？",
      })
        .then(() => {
          // on confirm
          let that = this;
          this.$api.get(
            "/api/user/addressDelete",
            { id: that.formData.id },
            (res) => {
              that.onChange();
            }
          );
        })
        .catch(() => {
          // on cancel
        });
    },
  },
};
</script>



// WEBPACK FOOTER //
// AddressEdit.vue?73de4135